import configuration from '../../../utilities/configuration';
import * as HttpUtility from "../../../utilities/HttpUtility";
import { sendRequestWithBearer } from "../../../utilities/EffectUtility";

export async function requestOrderFiles(userId, orderId, params) {
    const endpoint = configuration.apiServer + configuration.apiOrdersPath + "/" + userId + "/" + orderId + "/files";
    return await sendRequestWithBearer(HttpUtility.get, endpoint, params, true);
}

export async function requestUserSubscriptionFiles(userId, subscriptionId, params) {
    const endpoint = configuration.apiServer + configuration.apiSubscriptionsPath + "/" + subscriptionId + "/users/" + userId + "/files";
    return await sendRequestWithBearer(HttpUtility.get, endpoint, params, true);
}

export async function requestPublicLinkFiles(publicLinkId, params) {
    const endpoint = configuration.apiServer + configuration.apiPublicFilesPath + "/" + publicLinkId;
    return await sendRequestWithBearer(HttpUtility.get, endpoint, params, false, true);
}
